module.exports = __webpack_public_path__ + "img/shandianzhuanfa.4ae220f3.png";